import { useQuery } from '@tanstack/react-query';

import { getPetitionTitleImage } from './utils';

const QUERY_KEY = 'flyer-a';

type UsePetitionTitleImageArgs = { id: string; title: string };
export function usePetitionTitleImage({ id, title }: UsePetitionTitleImageArgs) {
	return useQuery({
		queryKey: [QUERY_KEY, id, title],
		queryFn: async () => getPetitionTitleImage(title),
	});
}
